import { FunctionComponent, SVGProps } from 'react';

import {
  WarningComplianceIcon,
  WarningLowYellowIcon,
  WarningOrangeIcon,
  WarningRedIcon,
  WarningYellowIcon
} from 'assets/icons';

type SvgIcon = FunctionComponent<SVGProps<SVGSVGElement>>;

const SEVERITY_ICONS: Record<string, SvgIcon> = {
  'warning-red': WarningRedIcon,
  'warning-orange': WarningOrangeIcon,
  'warning-yellow': WarningYellowIcon,
  'warning-low-yellow': WarningLowYellowIcon,
  'warning-compliance': WarningComplianceIcon
};

interface ISeverityIconProps {
  name: string;
  className?: string;
}

const SeverityIcon = ({ name, className }: ISeverityIconProps) => {
  const IconComponent = SEVERITY_ICONS[name];
  if (!IconComponent) return null;
  return <IconComponent className={`icon ${className || ''}`.trim()} />;
};

export default SeverityIcon;
